import React from 'react';
import { Info, TrendingUp, CheckCircle, Sparkles } from 'lucide-react';

/**
 * CoachTherapyBanner - Bandeau Coach pour encouragement
 * 
 * VERSION SIMPLIFIÉE: Affiche uniquement des messages d'encouragement génériques
 * sans référence au total quotidien (qui doit être consulté dans la page Progress)
 * 
 * @param {boolean} isPlaying - Si une thérapie est en cours
 * @param {string} language - Langue (fr/en)
 */
const CoachTherapyBanner = ({ 
  isPlaying = false,
  language = 'fr' 
}) => {
  // Messages d'encouragement simples sans calcul de progression quotidienne
  const getMessage = () => {
    if (isPlaying) {
      return {
        icon: TrendingUp,
        text: language === 'fr' 
          ? `💪 Excellente séance en cours ! Continuez pour profiter pleinement des bénéfices de l'écoute.`
          : `💪 Great session in progress! Stay immersed in your listening session.`,
        color: 'text-purple-300',
        bgColor: 'bg-purple-500/10',
        borderColor: 'border-purple-500/20'
      };
    }
    
    // Message d'information général quand aucune session n'est active
    return {
      icon: Info,
      text: language === 'fr'
        ? `🎯 Prêt pour votre session d'écoute sonore ? Sélectionnez un son pour commencer.`
        : `🎯 Ready for your sound therapy session? Select a sound to begin.`,
      color: 'text-white/80',
      bgColor: 'bg-white/5',
      borderColor: 'border-white/10'
    };
  };

  const message = getMessage();
  const Icon = message.icon;

  return (
    <div className="px-4 pb-4 animate-fade-in">
      <div 
        className={`
          ${message.bgColor} 
          ${message.borderColor}
          backdrop-blur-md 
          border 
          rounded-2xl 
          p-4 
          transition-all 
          duration-500
        `}
        style={{
          boxShadow: '0 0 20px rgba(159, 134, 255, 0.1)'
        }}
      >
        <div className="flex items-start gap-3">
          <Icon className={`w-5 h-5 ${message.color} flex-shrink-0 mt-0.5`} />
          <p className={`text-sm ${message.color} leading-relaxed`}>
            {message.text}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CoachTherapyBanner;
